import { HttpClient } from '@angular/common/http';
import { effect, inject, Injectable, signal } from '@angular/core';
import { ILoginRequest, IUserResponse } from '../interfaces/auth';
import { Observable, tap } from 'rxjs';
import { ApiResponse } from '@core/interfaces/generic-response';
import { Storage } from '@core/services/storage';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class Auth {
  private http = inject(HttpClient);
  private storage = inject(Storage);
  private router = inject(Router);
  private readonly LOCAL_KEY = 'auth_user';
  user = signal<IUserResponse | null>(this.storage.get<IUserResponse>(this.LOCAL_KEY));

  constructor() {
    effect(() => {
      const user = this.user()
      if (user) {
        this.storage.set(this.LOCAL_KEY, user)
      } else {
        this.storage.remove(this.LOCAL_KEY)
      }
    })
  }

  login(payload: ILoginRequest): Observable<ApiResponse<IUserResponse>> {
    return this.http.post<ApiResponse<IUserResponse>>(`auth/login`, payload).pipe(
      tap(res => {
        this.user.set(res.data)
        this.router.navigateByUrl('/')
      })
    );
  }

  logout() {
    return this.http.post(`auth/logout`, null).pipe(
      tap(() => this.clearSession())
    )
  }

  clearSession() {
    this.user.set(null)
    this.router.navigateByUrl('/auth')
  }
}
